/** Ghép class: cx('btn', on && 'on', size) */
export const cx = (...xs: (string | false | null | undefined | 0)[]) => xs.filter(Boolean).join(' ');
